import React, { useState } from 'react';

export default function RoomTypeFacilityModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState(() => initial ? { ...initial } : { name: '', description: '' });
  const [error, setError] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name) {
      setError('Name is required.');
      return;
    }
    onSave(form);
    onClose();
  };

  return (
    <div className="facility-modal-overlay">
      <div className="facility-modal">
        <h3>{initial ? 'Edit Facility' : 'Add Facility'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="modal-row">
            <label>Name</label>
            <input name="name" value={form.name} onChange={handleChange} required />
          </div>
          <div className="modal-row">
            <label>Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} />
          </div>
          {error && <div className="modal-error">{error}</div>}
          <div className="modal-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
